// extracted by mini-css-extract-plugin
export var expanded = "NavBar-module--expanded--hV2mS";
export var minimized = "NavBar-module--minimized--yup39";
export var navbar = "NavBar-module--navbar--bPfGM";